import { useMutation } from '@tanstack/react-query';
import api from '~/libs/api.ts';
import type { TKved } from '~/queries/types.ts';

const fetchKvedByCode = async (code: string): Promise<TKved> => {
  const { data } = await api.get<TKved>(`/dictionary-service/kved/${encodeURIComponent(code)}`);

  return data;
};

export const useKvedByCodeMutation = () =>
  useMutation({
    mutationFn: fetchKvedByCode,
  });
